import { Component, OnDestroy, OnInit } from "@angular/core";
import { StatusListener } from "../../../status-listener";
import { AppService } from "../../../services/app.service";
import { AppStatus } from "../../../@models/app-status";
import { nullSafe } from "../../../../shared/utils/core-utils";

@Component({
	selector: "app-mobileselectqr",
	templateUrl: "./mobileselectqr.component.html",
	styleUrls: ["./mobileselectqr.component.scss"]
})
export class MobileSelectQRComponent implements OnInit, OnDestroy {

	timer = 0;
	qrCodeUrl = "";
	lastQRChangeTime = 0;

	constructor(protected app: AppService) {
	}

	ngOnInit() {
		this.timer = window.setInterval(() => this.checkQRCode(), 1000);
		this.checkQRCode();
	}

	ngOnDestroy() {
		clearInterval(this.timer);
	}

	private checkQRCode() {
		const mobileSelect = this.app.getStatus().deviceStatus.MobileSelect;
		if (mobileSelect && mobileSelect.Enabled) {
			const changeSecs = Math.max(mobileSelect.StartCodeLifetimeSeconds - 10, 20);
			if (Date.now() > this.lastQRChangeTime + changeSecs * 1000) {
				this.lastQRChangeTime = Date.now();
				this.updateQRCode();
			}
		}
		else {
			this.qrCodeUrl = "";
		}
	}

	private updateQRCode() {
		console.log("!!!");
		this.qrCodeUrl = this.app.http.serverUrl + "/mobileselect/qrcode.png" +
			"?v=" + Date.now(); // To force reload of image
	}

}
